class SubFlowPopup extends HTMLElement {
  constructor() {
    super();

    this.body = document.querySelector('body');
    this.sellingId = 10005807170;
    const subpopupTriggers = document.querySelectorAll('.js-sub-popup-trigger');
    const popupClose = this.querySelector('.sub-popup-close');
    this.sizeAccordion = this.querySelector('.size-guide-accordion-label');
    this.sizeAccordionContent = this.querySelector('.size-guide-accordion-content');
    this.stepSizes = this.querySelector('.sub-popup-step-sizes');
    this.nextStep = this.querySelector('.js-to-act');
    this.sizeStepWrap = this.querySelector('.sub-popup-step-size');
    this.pairStepWrap = this.querySelector('.sub-popup-step-pair');
    this.backStepButton = this.querySelector('.sub-popup-back-button');
    this.pairCells = this.querySelectorAll('.pair-col-cell');
    this.atc = this.querySelector('.js--act');

    if(this.body){
        this.body.insertAdjacentElement('beforeend', this);
    }

    if(subpopupTriggers.length > 0){
        subpopupTriggers.forEach((subpopupTrigger) => {
            subpopupTrigger.addEventListener('click', ()=>{
                this.querySelector('.sub-popup-wrap').style.display = 'block';
                this.body.classList.add('popup-opened');
            })
        })
    }

    popupClose.addEventListener('click', ()=>{
        this.querySelector('.sub-popup-wrap').style.display = 'none';
        this.body.classList.remove('popup-opened');
    })

    if(this.sizeAccordion){
        this.sizeAccordion.addEventListener('click', this.sizeAccordionFunction.bind(this));
    }

    if(this.nextStep){
        this.nextStep.addEventListener('click', this.onPairSubscription.bind(this));
    }

    if(this.atc){
        this.atc.addEventListener('click', this.onAddToCart.bind(this));
    }

    if(this.backStepButton){
        this.backStepButton.addEventListener('click', this.onSizeStepOpen.bind(this));
    }

    if(this.pairCells.length > 0){
        this.pairCells.forEach((pairCell) => {
            pairCell.addEventListener('click', this.pairCellEvent.bind(this));
        });
    }

    this.addEventListener('change', this.onInputSizeChange.bind(this));
  }

  sizeAccordionFunction(){
    if (this.sizeAccordionContent.classList.contains("open")) {
        // close
        this.sizeAccordionContent.style.height = this.sizeAccordionContent.scrollHeight + "px";
        requestAnimationFrame(() => {
            this.sizeAccordionContent.style.height = "0px";
        });
        this.sizeAccordionContent.classList.remove("open");
    } else {
        // open
        this.sizeAccordionContent.style.height = "0px";
        requestAnimationFrame(() => {
            this.sizeAccordionContent.style.height = this.sizeAccordionContent.scrollHeight + "px";
        });
        this.sizeAccordionContent.classList.add("open");
    }
  }

  onInputSizeChange(){
    this.sizeStepButton = this.querySelector('.size-step-button');
    const pairCell = this.querySelector('.pair-col-list.active .pair-col-cell.active');
    
    if(this.sizeStepButton){
        this.sizeStepButton.style.display = 'block';
    }

    const productId = pairCell.getAttribute('data-productid');
    this.selectedProduct = this.getSelectedProduct(productId);
    this.selectedVariant = this.getSelectedVariant(this.selectedProduct);

    if(this.selectedVariant.available){
        this.atc.removeAttribute('disabled');
    }else{
        this.atc.setAttribute('disabled', 'disabled');
    }
  }

  onPairSubscription(){
    this.sizeStepWrap.style.display = 'none';
    this.pairStepWrap.style.display = 'block';
  }

  onSizeStepOpen(){
    this.sizeStepWrap.style.display = 'block';
    this.pairStepWrap.style.display = 'none';
  }

  pairCellEvent(e){
    const pairCell = e.target.classList.contains('.pair-col-cell') ? e.target : e.target.closest('.pair-col-cell');
    const pairList = e.target.closest('.pair-col-list');
    const pairLabel = this.querySelector('.js-pair-label');
    
    pairList.querySelectorAll('.pair-col-cell').forEach((pairCell) => {
        pairCell.classList.remove('active');
    });

    pairCell.classList.add('active');

    this.onInputSizeChange();
    pairLabel.innerText = this.selectedProduct.title;

    this.updateProductImage(this.selectedProduct);
  }

  getSelectedProduct(productid){
    const selectedProduct = subProducts.find((subProduct) => subProduct.id == productid);

    return selectedProduct;
  }

  getSelectedVariant(product){
    const selectedSize = this.querySelector('input[name="sub-popup-step-input"]:checked').value;
    this.options = [selectedSize];

    const currentVariant = product.variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    return currentVariant;
  }

  updateProductImage(product){
    if(!product) return false;

    const productImage = `${product.featured_image}&width=600`;
    const imageWrap = this.querySelector('.pair-step-image-container img');

    imageWrap.removeAttribute('srcset');
    imageWrap.src = productImage;
  }

  onAddToCart(e){
    const button = e.target;
    this.onInputSizeChange();

    button.disabled = true;
    let formData = {
      'items': [{
        'id': this.selectedVariant.id,
        'quantity': 1,
        'selling_plan': this.sellingId,
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then((response) => {
      button.removeAttribute('disabled');
      this.onSizeStepOpen();
      this.querySelector('.sub-popup-wrap').style.display = 'none';
      this.body.classList.remove('popup-opened');
      window.monster_refresh();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

customElements.define('sub-flow-popup', SubFlowPopup);